/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_auth_have_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already have an account? Sign in`)
};

const es_auth_have_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Ya tienes cuenta? Inicia sesión`)
};

const de_auth_have_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereits ein Konto? Anmelden`)
};

const nl_auth_have_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al een account? Inloggen`)
};

const fr_auth_have_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déjà un compte ? Se connecter`)
};

const it_auth_have_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai già un account? Accedi`)
};

const pt_br2_auth_have_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já tem conta? Entre`)
};

const pt_auth_have_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já tem conta? Inicie sessão`)
};

const ja_auth_have_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すでにアカウントをお持ちの方はログイン`)
};

const zh_auth_have_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已有账户？立即登录`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const auth_have_account = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.auth_have_account(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("auth_have_account", locale)
	if (locale === "en") return en_auth_have_account(inputs)
	if (locale === "es") return es_auth_have_account(inputs)
	if (locale === "de") return de_auth_have_account(inputs)
	if (locale === "nl") return nl_auth_have_account(inputs)
	if (locale === "fr") return fr_auth_have_account(inputs)
	if (locale === "it") return it_auth_have_account(inputs)
	if (locale === "pt-BR") return pt_br2_auth_have_account(inputs)
	if (locale === "pt") return pt_auth_have_account(inputs)
	if (locale === "ja") return ja_auth_have_account(inputs)
	return zh_auth_have_account(inputs)
};